import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import IconInit from "./helpers/IconInit";
import RouterScrollToTop from "./helpers/RouterScrollToTop";
import HomePage from "./pages/HomePage";
// import "../public/assets/css/slick.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import ShopPage from "./pages/ShopPage";
import ContactPage from "./pages/ContactPage";
import DynamicProductDetail from "./pages/DynamicProductDetail";
import WishlistPage from "./pages/WishlistPage";

import Auth from "./pages/Auth";
import { AuthProvider } from "./hooks/useAuth";
import { WishlistProvider } from "./hooks/useWishlistContext";
import CartCheckoutPage from "./pages/CartCheckOutPage";
import Tracking from "./pages/Tracking";
import { SplashScreen } from "./layout/SplashScreen/SplashScreen";
// Initialize security middleware
import "./utils/securityInit";
import ProductPage from "./pages/ProductPage";

import UpdatePassword from "./pages/UpdatePassword";
import ForgetPassword from "./pages/ForgetPassword";

const App: React.FC = () => {
  const [showSplash, setShowSplash] = useState(true);
  const [splashLoaded, setSplashLoaded] = useState(false);

  useEffect(() => {
    // Check if user has seen splash before (optional - remove these lines to always show splash)
    // const hasSeenSplash = localStorage.getItem('hasSeenSplash');
    // if (hasSeenSplash) {
    //   setShowSplash(false);
    //   setSplashLoaded(true);
    //   return;
    // }

    // Always show splash screen for demo purposes
    setSplashLoaded(true);
  }, []);

  const handleSplashComplete = () => {
    setShowSplash(false);
    localStorage.setItem("hasSeenSplash", "true");
  };

  if (!splashLoaded) {
    return null; // Prevent flash of content
  }
  return (
    <AuthProvider>
      <WishlistProvider>
        {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
        <BrowserRouter>
          <RouterScrollToTop />
          <IconInit />

          <div className="min-h-screen flex flex-col">
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                {/* <Route path="shop" element={<ShopPage />} /> */}
                <Route path="contact" element={<ContactPage />} />
                <Route
                  path="product/:productId"
                  element={<DynamicProductDetail />}
                />
                <Route path="cart" element={<CartCheckoutPage />} />
                <Route path="products" element={<ProductPage />} />
                <Route path="tracking" element={<Tracking />} />
                <Route path="wishlist" element={<WishlistPage />} />
                {/* <Route path="signin" element={<SignIn />} /> */}

                <Route path="registration" element={<Auth />} />
                <Route path="forget-password" element={<ForgetPassword />} />
                <Route path="reset-password" element={<UpdatePassword />} />
                <Route path="*" element={<div>404 Not Found</div>} />
              </Routes>
            </main>
          </div>
        </BrowserRouter>
      </WishlistProvider>
      {/* React Query DevTools - only in development */}
      {process.env.NODE_ENV === "development" && <ReactQueryDevtools />}
    </AuthProvider>
  );
};

export default App;
